@let candidateIdValue = candidateId();

@if (candidateIdValue) {
  <rt-button
    #addEvaluationDropdownOrigin="rtOverlayOrigin"
    variant="primary"
    [pressed]="addEvaluationDropdown.open"
    [rtTooltip]="'app.interview.evaluate_button_label' | translate"
    [rtTooltipEnabled]="iconOnly()"
    (click)="addEvaluationDropdown.open = true"
    rt-overlay-origin
  >
    <rt-icon name="add" />
    @if (!iconOnly()) {
      <span> {{ 'app.interview.evaluate_button_label' | translate }}</span>
    }
  </rt-button>

  <ng-template
    #addEvaluationDropdown="rtConnectedOverlay"
    [positions]="positions"
    [origin]="addEvaluationDropdownOrigin"
    (backdropClick)="addEvaluationDropdown.open = false"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-add-evaluation-dropdown
      [offers]="offers()"
      [candidateId]="candidateIdValue"
      (close)="addEvaluationDropdown.open = false"
      (addEvaluation)="onAddEvaluation($event)"
      (addQuickEvaluation)="onAddQuickEvaluation()"
    />
  </ng-template>
}
